/**
 * formats to be listed here are formats, supported by date-fns
 * look into date-fns specification for details
 */
enum DateFnsFormats {
    NumericDateTime12Hours = 'dd/MM/yy h:mm a',
    StringifiedDayMonthNumericDateYear = 'EEEE, MMMM d, yyyy',
    FullDate = 'yyyy-MM-dd HH:mm:ss.sssz',
    StringifiedFullDayMonthNumericDateYear = 'EEEE, MMMM dd, yyyy',
    StringifiedShortDay = 'EEEE MM/dd',
    StringifiedShortFullDateDay12Hours = 'EE MM/dd/yyy',
    StringifiedShortFullDateDay24Hours = 'EE dd/MM/yyy',
    ShortDayDate = 'MM/dd',
    ShortDayMonthYear12Hours = 'MM/dd/yyy',
    ShortDayMonthYear24Hours = 'dd/MM/yyy',
    StringifiedShortDayMonthNumericDateYear12Hours = 'EEE MMM d, yyyy',
    StringifiedShortDayMonthNumericDateYear24Hours = 'EEE d MMM, yyyy',
    StringifiedDayMonthNumericDateYear24Hours = 'EEEE d MMMM',
    StringifiedMonthDayYear = 'MMMM d, yyyy',
    StringifiedShortYearMonthDayDate = 'yyyy-MM-dd',
    StringifiedMonthDayYearTime = 'MMMM d, yyyy, h:mm a',
    StringifiedShortDayMonthYearDate = 'dd MMMM yy',
    StringifiedShortDayMonthDateYearDate = 'EEE, MMM dd, yyyy',
    ShortMonthDay = 'MMM-dd'
}

enum DateFormats {
    USDateFormatNormalized = 'MM/dd/yy',
    USDateFormat = 'MM/DD/YYYY',
    EUDateFormat = 'DD/MM/YYYY',
    DayAndMonthFormat = 'do MMMM',
}

enum TimeFormats {
    Day12Hours = 'h:mm a',
    Day24Hours = 'H:mm',
    HoursMinutesSeconds = 'HH:mm:ss',
}

abstract class IDateTimeFormatter {
    /**
     * converts the date to it's string representation within the specified timezone
     * if timezone is not set - use default user timezone
     * @param date
     * @param format
     * @param timezone
     */
    public abstract dateToFormattedString(date: Date, format: string, timezone?: string): string;


    /**
     * Returns time format corresponded to system settings
     * @return {TimeFormats}
     */
    public abstract getLocalTimeFormat(): TimeFormats;

    /**
     * converts date to local string representation within the specified timezone
     * @param {Date} date
     * @param {string} timezone
     * @return {string}
     */
    public abstract dateToLocalString(date: Date, timezone?: string): string;
}

export { IDateTimeFormatter, DateFnsFormats, TimeFormats, DateFormats };
